import { render, staticRenderFns } from "./ColorScroller.vue?vue&type=template&id=69a81bfa&scoped=true&lang=pug"
import script from "./ColorScroller.vue?vue&type=script&lang=js"
export * from "./ColorScroller.vue?vue&type=script&lang=js"
import style0 from "./ColorScroller.vue?vue&type=style&index=0&id=69a81bfa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a81bfa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69a81bfa')) {
      api.createRecord('69a81bfa', component.options)
    } else {
      api.reload('69a81bfa', component.options)
    }
    module.hot.accept("./ColorScroller.vue?vue&type=template&id=69a81bfa&scoped=true&lang=pug", function () {
      api.rerender('69a81bfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/ColorScroller.vue"
export default component.exports